import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationPage from "src/components/StatusBackground/ConfirmationPage";

const ExistingUser = () => {
  const { t } = useTranslation();
  return (
    <ConfirmationPage title={t("existingUser.title")} icon="svg/Check.svg">
      <h4>{t("existingUser.welcomeTitle")}</h4>
      <h4>{t("existingUser.instructionsTitle")}</h4>
      <p>{t("existingUser.thankYou")}</p>
      <p>{t("existingUser.requestSent")}</p>
      <p>{t("existingUser.staffContact")}</p>
      <p>{t("existingUser.pickupInfo")}</p>
    </ConfirmationPage>
  );
};

export default ExistingUser;
